import type { Thing, WithContext } from "schema-dts";

export default function useSchema<T extends Thing>(json: WithContext<T> | Array<WithContext<T>>) {
    return JSON.stringify(json);
}
